package ui.app.assign.detail.wheel.editor.widgets

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.StringResource
import tools.EFieldRegularBoolean
import tools.rememberString
import ui.app.assign.detail.wheel.editor.AppEditorWheelScope

@Composable
fun AppEditorWheelScope.FieldSwitch(
    label: StringResource,
    field: EFieldRegularBoolean,
    modifier: Modifier = Modifier,
    desc: StringResource? = null,
) {
    Card(
        onClick = { field.set(!field.state) },
        modifier = modifier
    ) {
        Column {
            Row(
                Modifier.padding(8.dp),
                horizontalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                Switch(
                    checked = field.state,
                    onCheckedChange = { field.set(it) },
                    modifier = Modifier.align(Alignment.CenterVertically)
                )
                Text(
                    text = label.rememberString(),
                    style = MaterialTheme.typography.titleMedium,
                    modifier = Modifier.align(Alignment.CenterVertically)
                )
            }
            desc?.rememberString()?.also {
                HorizontalDivider(Modifier.fillMaxWidth().padding(horizontal = 8.dp))
                Text(
                    text = it,
                    modifier = Modifier.padding(8.dp),
                    style = MaterialTheme.typography.labelMedium
                )
            }
        }
    }
}